import * as types from "~/store/resource/resourceType";

// term of service
export const getTermOfService = () => {
  return { type: types.GET_TERM_OF_SERVICE_REQUEST };
};

// introduction
export const getIntroduction = () => {
  return {
    type: types.GET_INTRODUCTION_REQUEST
  };
};
export const getIntroductionSuccess = payload => {
  return {
    type: types.GET_INTRODUCTION_SUCCESS,
    payload
  };
};
export const getIntroductionFail = payload => {
  return {
    type: types.GET_INTRODUCTION_FAIL,
    payload
  };
};

// private policy
export const getPrivatePolicy = () => {
  return {
    type: types.GET_PRIVATE_POLICY_REQUEST
  };
};

// usageRules
export const getUsageRules = () => {
  return { type: types.GET_USAGE_RULES_REQUEST };
};

// term before login
export const getTermBeforeLogin = () => {
  return {
    type: types.GET_TERM_BEFORE_LOGIN
  };
};

export const getTermBeforeLoginSuccess = data => {
  return {
    type: types.GET_TERM_BEFORE_LOGIN_SUCCESS,
    data
  };
};

export const getTermBeforeLoginFail = error => {
  return {
    type: types.GET_TERM_BEFORE_LOGIN_FAIL,
    error
  };
};

// HOLIDAY
export const requestHoliday = () => {
  return {
    type: types.GET_HOLIDAY_REQUEST
  };
};

// BANNER LIST
export const requestBannerList = () => {
  return { type: types.GET_BANNER_LIST_REQUEST };
};

// CAREER
export const requestAllCareers = () => {
  return {
    type: types.GET_ALL_CAREERS_REQUEST
  };
};
export const onChangeCareer = selectedCareer => {
  return {
    type: types.CHANGE_CAREER,
    selectedCareer
  };
};

// NATION
export const requestAllNation = () => {
  return {
    type: types.GET_ALL_NATION_REQUEST
  };
};
export const onChangeNation = selectedNation => {
  return {
    type: types.CHANGE_NATION,
    selectedNation
  };
};

// COUNTRY
export const requestAllCountries = () => {
  return {
    type: types.GET_ALL_COUNTRIES_REQUEST
  };
};
export const onChangeCountry = selectedCountry => {
  return {
    type: types.CHANGE_COUNTRY,
    selectedCountry
  };
};
export const resetSelectedCountry = () => {
  return {
    type: types.RESET_SELECTED_COUNTRY
  };
};

// CITY
export const requestAllCity = () => {
  return {
    type: types.GET_ALL_CITIES_BY_COUNTRY_REQUEST
  };
};
export const onChangeCity = selectedCity => {
  return {
    type: types.CHANGE_CITY,
    selectedCity
  };
};
export const resetCity = () => {
  return {
    type: types.RESET_CITY
  };
};

// DISTRICT
export const requestAllDistrict = () => {
  return {
    type: types.GET_ALL_DISTRICTS_BY_CITY_REQUEST
  };
};
export const onChangeDistrict = selectedDistrict => {
  return {
    type: types.CHANGE_DISTRICT,
    selectedDistrict
  };
};
export const resetDistrict = () => {
  return {
    type: types.RESET_DISTRICT
  };
};

// WARD
export const onChangeWard = selectedWard => {
  return {
    type: types.CHANGE_WARD,
    selectedWard
  };
};
export const resetWard = () => {
  return {
    type: types.RESET_WARD
  };
};

// RELATIONSHIP
export const requestAllRelationShip = () => {
  return {
    type: types.GET_ALL_RELATIONSHIP_REQUEST
  };
};
export const onChangeRelationShip = selectedRelationShip => {
  return {
    type: types.CHANGE_RELATIONSHIP,
    selectedRelationShip
  };
};
